import { Injectable } from "@angular/core";
import { UserRepositoryInterface } from "./user.interface";
import { RemoteRepositoryInterface } from "../../remote/remote.interface";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { UserModel } from "../../entities/user.model";
import { ResourceModel } from "../../entities/resource.model";
import { LoginResponseModel } from "../../entities/loginresponse.model";
import {
    CHANGE_PASSWORD_ENDPOINT,
    INFO_PLANT_API_URL,
    INFO_PLANT_CODE,
    INFO_PLANT_USER_ENDPOINT,
    LOGIN_ENDPOINT,
    ME_ENDPOINT,
    USER_ENDPOINT,
    AUTOCREATED_INFOPLANT_USER_PASSWORD
} from "../../../crossconcern/utilities/properties/base.property";
import { HttpHeaders } from "@angular/common/http";
import { ChangePasswordResponseModel } from "../../entities/changepasswordresponse.model";
import { InfoPlantUserModel } from "../../entities/infoplantuser.model";

@Injectable()
export class UserRepository implements UserRepositoryInterface {

    constructor(private remoteRepository: RemoteRepositoryInterface) {}

    public login(email: string, password: string): Observable<LoginResponseModel> {
        const body = {
            email,
            password
        };
        let headers = new HttpHeaders();
        headers = headers.append("X-Requested-With", "XMLHttpRequest");
        return this.remoteRepository.post(LOGIN_ENDPOINT, body, headers)
            .pipe(
                map((data) => new LoginResponseModel(data as JSON))
            );
    }

    public getLoggedUser(): Observable<UserModel> {
        return this.remoteRepository.get(USER_ENDPOINT + ME_ENDPOINT)
            .pipe(
                map((data) => new UserModel(data as JSON))
            );
    }

    public getInfoPlantUser(email: string, password: string): Observable<InfoPlantUserModel> {
        return this.remoteRepository.get(
            INFO_PLANT_USER_ENDPOINT +
            "?code=" + INFO_PLANT_CODE +
            "&email=" + email +
            "&pass=" + password +
            "&lan=2", null, INFO_PLANT_API_URL)
            .pipe(
                map((data) => new InfoPlantUserModel(data as JSON))
            );
    }

    public getProfile(id: number): Observable<UserModel> {
        return this.remoteRepository.get(USER_ENDPOINT + id.toString()).pipe(
            // Mock API returns data: { data: ... }
            // eslint-disable-next-line dot-notation
            map((response) => response["data"]),
            // create UserModel instance from generic object returned
            map((user) => new UserModel(user as JSON))
        );
    }

    public getResources(): Observable<ResourceModel[]> {
        return this.remoteRepository.get("unknown").pipe(
            // Mock API returns data: { data: ... }
            // eslint-disable-next-line dot-notation
            map((response) => response["data"]),
            // create ResourceModel instances from array of generic objects returned
            map((resources: []) => resources.map((resource) => new ResourceModel(resource as JSON)))
        );
    }

    /* eslint-disable camelcase, @typescript-eslint/camelcase */
    public changePassword(
        oldPassword: string,
        newPassword: string,
        userId: string): Observable<ChangePasswordResponseModel> {
        const body = {
            old_password: oldPassword,
            new_password: newPassword
        };
        return this.remoteRepository.update(USER_ENDPOINT + userId + CHANGE_PASSWORD_ENDPOINT, body)
            .pipe(
                map((data) => new LoginResponseModel(data as JSON))
            );
    }

    public createUser(userEmail: string): Observable<UserModel> {
        const body = {
            first_name: "Utente",
            last_name: "Esterno",
            email: userEmail,
            password: AUTOCREATED_INFOPLANT_USER_PASSWORD
        };
        return this.remoteRepository.post(USER_ENDPOINT, body)
            .pipe(
                map((data) => new UserModel(data as JSON))
            );
    }
}
